import { render, staticRenderFns } from "./userClassInfo.vue?vue&type=template&id=52b82e1d&scoped=true&"
import script from "./userClassInfo.vue?vue&type=script&lang=js&"
export * from "./userClassInfo.vue?vue&type=script&lang=js&"
import style0 from "./userClassInfo.vue?vue&type=style&index=0&id=52b82e1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b82e1d",
  null
  
)

export default component.exports